import { FormlyFieldConfig } from '@ngx-formly/core';
import { LuRadioSelectOption, RadioTemplateType } from '../components/lu-radio/lu-radio.model';
import { LuFormlyBuilder } from '../formly.builder';
import { FieldType } from './formly-builder.models';

export class LuFormlyRadioBuilder<T = any> extends LuFormlyBuilder {
	protected type = FieldType.RADIO;
	private options: LuRadioSelectOption[];
	private parsers: ((value: T) => {})[];
	private radioTemplateType = RadioTemplateType.DEFAULT;

	constructor(key: string, options: LuRadioSelectOption[], label: string, className?: string) {
		super(key, label, null, className);
		this.options = options;
	}

	setParser(parsers: ((value: T) => {})[]): this {
		this.parsers = parsers;
		return this;
	}

	setTemplateType(templateType: RadioTemplateType): this {
		this.radioTemplateType = templateType;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();
		field.templateOptions.templateType = this.radioTemplateType;
		field.templateOptions.options = this.options.map(item => {
			const { label, value, disabled, ariaLabel, icon = '', description = '', additionalFields = [] } = item;
			return {
				label,
				value,
				disabled: !!disabled,
				ariaLabel,
				icon,
				description,
				additionalFields
			};
		});

		field.parsers = this.parsers;
		return field;
	}
}
